import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';

export const DataFetchSpinner = memo(({width, height, strokeWidth}) => {
    return (
        <SpinnerContainer width={width} height={height} viewBox='0 0 66 66' xmlns='http://www.w3.org/2000/svg'>
            <SpinnerCircle fill='none' strokeWidth={strokeWidth} stroke-linecap='round' cx='33' cy='33' r='30'></SpinnerCircle>
        </SpinnerContainer>
    );
});

DataFetchSpinner.displayName = 'DataFetchSpinner';

DataFetchSpinner.propTypes = {
    translateKey: PropTypes.string,
    link: PropTypes.string
};

const fetchRotator = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(270deg); }
`;

const SpinnerContainer = styled.svg`
    animation-name: ${fetchRotator};
    animation-duration: 1.9s;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
`;

const dash = keyframes`
    0% {
        stroke-dashoffset: 187;
    }
    25% {
        stroke-dashoffset: 187/2;
        transform:rotate(90deg);
    }
    50% {
        stroke-dashoffset: 187/4;
        transform:rotate(180deg);
    }
    100% {
        stroke-dashoffset: 187;
        transform:rotate(360deg);
    }
`

const SpinnerCircle = styled.circle`
    stroke-dasharray: 120;
    stroke-dashoffset: 0;
    transform-origin: center;
    stroke: #eeeeee;
    animation-name: ${dash};
    animation-duration: 1.9s;
    animation-timing-function: ease-in-out;
    animation-iteration-count: infinite;
`;
